module.exports = __webpack_public_path__ + "0f7eb84dd20312ee0dd2ca623122a488.pdf";